import React from "react";

const Opencomp = () => {
  return (
    <div className="sales-tool-root">
      <h1>Opencomp comp</h1>
    </div>
  );
};

export default Opencomp;